import { render, staticRenderFns } from "./InsightsSlide.vue?vue&type=template&id=748346d8&scoped=true"
import script from "./InsightsSlide.vue?vue&type=script&lang=ts"
export * from "./InsightsSlide.vue?vue&type=script&lang=ts"
import style0 from "./InsightsSlide.vue?vue&type=style&index=0&id=748346d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748346d8",
  null
  
)

export default component.exports